module.exports = __webpack_public_path__ + "static/media/CTLI_10-111w.2d93874c.webp";